<template>
  <div class="index-page" v-if="homepageData">
    <index-banner :banner="homepageData.banner" :search="homepageData.available_country"></index-banner>
    <template v-if="!User.isLogin()">
      <!-- 未登录的状态 -->
      <index-introduce></index-introduce>
      <index-service></index-service>
      <index-case></index-case>
      <index-article :hot-article="homepageData.hot_article" :recommend-article="homepageData.recommend_article"></index-article>
      <index-about-us></index-about-us>
      <index-register></index-register>
    </template>
    <template v-else>
      <!-- 已登录 -->
      <index-notice :notice-list="homepageData.notice" @switchAllEmbassyHolidayPop="switchAllEmbassyHolidayPop" @switchEarlistDatePop="switchEarlistDatePop"></index-notice>
      <div>
        <index-three-order-activity ref="indexThreeOrderActivity" v-if="hasThreeOrderActivity" :full-order-activity="homepageData.full_order_activity" :show-coupon="!equityActivityModal.show"></index-three-order-activity>
        <index-order v-else></index-order>
      </div>
      <index-hot-product></index-hot-product>
      <template v-if="!is_palmyou && homepageData.activity && homepageData.activity.length">
        <template v-for="(item, index) in homepageData.activity">
          <index-activity :activity-info="item" :activity-index="index" :key="index" v-if="item.activity_product.length"></index-activity>
        </template>

      </template>

      <index-article :hot-article="homepageData.hot_article" :recommend-article="homepageData.recommend_article"></index-article>
    </template>




    <!-- 权益活动: 三单挑战和满额活动 -->
    <equity-activity-dialog
      v-if="equityActivityModal.show"
      :visible="equityActivityModal.show"
      :full-order-activity="equityActivityModal.activityInfo"
      @close="equityActivityModal.show=false"
      :component-info="equityActivityModal.componentInfo">
    </equity-activity-dialog>


    <!-- 新人优惠券弹窗 -->
    <new-people-activity-dialog
      v-else-if="newPeopleActivityModal.show"
      :visible="newPeopleActivityModal.show"
      :couponList="newPeopleActivityModal.couponList"
      :activityInfo="newPeopleActivityModal.activityInfo"
      :isExpire="newPeopleActivityModal.isExpire"
      @close="closeNewPeopleActivityDialog"
    ></new-people-activity-dialog>

    <!-- 营销弹窗，不显示后显示优惠卷相关弹窗 -->
    <marketing-modal v-else-if="showMarketingModal" v-model="showMarketingModal" :marketing-modal-info="marketingModalInfo"></marketing-modal>

    <template v-else>
      <!-- 充值赠送优惠券弹窗 -->
      <charge-coupon v-model="showChargeCoupon" :chargeCouponData="chargeCouponData"></charge-coupon>
    </template>

    <jingzonglv-modal :show="showJingzonglvModal" @visibleSync='visibleSync'></jingzonglv-modal>
    <visa-dialog
      :show="bdPhoneBindModal"
      :widthClass="'width420'"
      titleInfo="联系手机号"
      :showClose="false"
      top="35%"
      :closeOnClickModal="false">

      <div class="modal-body">

        <div class="input-box">
          <p class="text">首次使用请填写手机号，更新订单签证状态将短信通知</p>
          <el-input v-model="inputPhone" :maxlength="11" placeholder="手机号" @change="checkPhone"></el-input>
        </div>

        <!-- 底部按钮 -->
        <div class="footer-box">
          <el-button :class="['submit-btn', (inputPhone.length !== 11) || (+inputPhone[0] !== 1) ? 'disabled' : '']" @click="submitPhone" :disabled="(inputPhone.length !== 11) || (+inputPhone[0] !== 1)">确定</el-button>
        </div>
      </div>

    </visa-dialog>

    <!-- 所有使馆放假日期 -->
    <all-embassy-holiday-pop v-model="showAllEmbassyHolidayPop"></all-embassy-holiday-pop>

    <!-- 最早可预约时间弹窗 -->
    <earlist-date-pop v-model="showEarlistDatePop"></earlist-date-pop>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import bus from '@/libs/bus';
import sensorsdata from 'sa-sdk-javascript';

import Http from '../../libs/http';
import User from '../../libs/user';
import utils from '../../libs/utils';
import dateUtils from '../../libs/date-util';

import indexBanner from './components/index-banner';
import indexIntroduce from './components/index-introduce';
import indexService from './components/index-service';
import indexCase from './components/index-case';
import indexArticle from './components/index-article';
import indexAboutUs from './components/index-about-us';
import joinNow from './components/join-now';
import chargeCoupon from '../../components/coupon/charge-coupon';
import jingzonglvModal from './components/jingzonglv-modal';
import visaDialog from '../../components/common/modals/visa-dialog/visa-dialog';
import couponModal from '../../components/coupon/coupon-modal';
import indexNotice from './components/index-notice';
import indexOrder from './components/index-order';
import indexHotProduct from './components/index-hot-product';
import indexActivity from './components/index-activity/index-activity.vue';
import indexRegister from './components/index-register';
import indexThreeOrderActivity from './components/index-three-order-activity';
import allEmbassyHolidayPop from './components/all-embassy-holiday-pop';
import earlistDatePop from './components/earlist-date-pop';
import marketingModal from './components/marketing-modal';
import NewPeopleActivityDialog from './components/new-people-activity-dialog/new-people-activity-dialog.vue';
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';
import equityActivityDialog from './components/equity-activity-dialog/equity-activity-dialog.vue';


export default {
  components: {
    indexBanner,
    indexIntroduce,
    indexService,
    indexCase,
    indexArticle,
    indexAboutUs,
    joinNow,
    couponModal,
    chargeCoupon,
    jingzonglvModal,
    visaDialog,
    indexNotice,
    indexOrder,
    indexHotProduct,
    indexRegister,
    indexThreeOrderActivity,
    allEmbassyHolidayPop,
    earlistDatePop,
    marketingModal,
    NewPeopleActivityDialog,
    NoticeModal,
    equityActivityDialog,
    indexActivity,
  },
  data() {
    return {
      User,
      homepageData: null,
      unreadCoupons: [],
      showChargeCoupon: false, // 是否显示充值赠送优惠券
      chargeCouponData: {}, // 充值赠送优惠券数据
      showJingzonglvModal: false,
      inputPhone: '',
      bdPhoneBindModal: false,
      showAllEmbassyHolidayPop: false, // 全部使馆放假日历弹窗
      showEarlistDatePop: false, // 最早可预约时间弹窗
      showMarketingModal: false, // 显示营销弹窗
      marketingModalInfo: {}, // 当前营销弹窗的信息
      newPeopleActivityModal: { // 新人优惠券活动弹窗
        show: false,
        activityInfo: {}, // 活动信息
        couponList: [],
        isExpire: false, // 是否是过期的提醒
      },
      equityActivityModal: { // 权益活动弹窗
        show: false,
        activityInfo: {},
        componentInfo: {
          height: 0,
          width: 0,
          left: 0,
          top: 0,
        },
      },
    };
  },
  computed: {
    ...mapState('user', [
      'userInfo',
    ]),
    is_palmyou() {
      return this.userInfo.is_palmyou;
    },
    // 是否有三单挑战
    hasThreeOrderActivity() {
      if (!this.homepageData || !this.homepageData.full_order_activity) return; 
      // 活动是否过期 + 是否已经完成三单挑战
      return this.homepageData.full_order_activity.remaining_seconds && !this.homepageData.full_order_activity.is_complete;
    },
  },
  created() {
  },
  activated() {
    let url = '';
    if (!User.isLogin()) {
      url = '/sys/visa_homepage';
    } else {
      url = '/visa_homepage';
    }
    Http.post(url)
      .then((data) => {
        this.homepageData = data;
      });
    if (User.isLogin()) {
      // 引导关注微信公众号弹窗显示时不显示充值送券弹窗
      if (!this.$store.state.followOA.qrcodeModalShow) {
        this.initModal();
      } else {
        // 监听关闭弹窗事件，关闭了就重新执行其余弹窗显示逻辑
        bus.$on('close-follow-official-accounts-modal', () => {
          this.initModal();
        });
      }

      // 提示密码修改弹窗
      this.showUpdatePwdSafetyTip();

      setTimeout(() => {
        this.initPalmModalStatus();
      }, 300);
    }
  },
  watch: {
    hasThreeOrderActivity(val) {
      if (val) {
        this.$nextTick(() => {
          if (!this.$refs.indexThreeOrderActivity) return;
          const el = this.$refs.indexThreeOrderActivity.$el;
          this.equityActivityModal.componentInfo = {
            top: el.getBoundingClientRect().top || 0,
            left: el.getBoundingClientRect().left || 0,
            height: el.offsetHeight || 0,
            width: el.offsetWidth || 0,
          };
        });
      }
    },
  },
  mounted() {
    
  },
  methods: {
    ...mapActions('chargeActivity', [
      'getChargeActivity',
    ]),
    // 初始化弹窗
    initModal() {
      this.initShowEquityActivity();
      this.initShowNewPeopleActivity();
      this.loadMarketingActivity();
      this.getChargeActivity(true).then((data) => {
        this.getChargeCouponData(data);
      });
    },
    // 是否显示权益活动： 三单活动+满额活动
    initShowEquityActivity() {
      // 0-否 1-是（权益中心-0 弹窗-1）
      Http.post('/full_order_activity_query', { is_need_complete_coupon: 1 }).then((data) => {
        this.equityActivityModal.activityInfo = data.full_order_activity;
        if (data.full_order_activity && data.full_order_activity.remaining_seconds) { // 是否过期
          this.equityActivityModal.show = true;
        }
      });
    },
    // 是否显示新人优惠活动
    initShowNewPeopleActivity() {
      Http.post('/coupon_newcomer_query', {}).then((data) => {
        if (!data.operating_activity_id || !data.peer_coupon_set || !data.peer_coupon_set.length) {
          this.newPeopleActivityModal.show = false;
          return;
        }
        // 是否显示过活动
        const showedActivity = localStorage.getItem(`new_people_activity_${data.operating_activity_id}_${this.userInfo.visa_peer_id}`);
        // 显示过的优惠券过期提醒
        let showedCouponIds = localStorage.getItem(`new_people_activity_${data.operating_activity_id}_${this.userInfo.visa_peer_id}_expire_coupon`);
        showedCouponIds = showedCouponIds ? JSON.parse(showedCouponIds) : [];
        if (!showedActivity) {
          // 显示获得新人优惠券
          this.newPeopleActivityModal.show = true;
          this.newPeopleActivityModal.couponList = data.peer_coupon_set;
          this.newPeopleActivityModal.activityInfo = data;
          this.newPeopleActivityModal.isExpire = false;
        } else {
          const showCouponList = data.peer_coupon_set.filter((coupon) => {
            const isExpire = (dateUtils.getDateDayDiff(new Date(), coupon.end_date) + 1) <= data.expiration_reminders_days;
            return isExpire && showedCouponIds.every(id => id !== coupon.id);
          });
          if (showCouponList.length) {
            // 显示过
            this.newPeopleActivityModal.show = true;
            this.newPeopleActivityModal.couponList = showCouponList;
            this.newPeopleActivityModal.activityInfo = data;
            this.newPeopleActivityModal.isExpire = true;
          } else {
            this.newPeopleActivityModal.show = false;
          }
        }
      });
    },
    // 关闭新人优惠活动
    closeNewPeopleActivityDialog() {
      this.newPeopleActivityModal.show = false;
      if (!this.newPeopleActivityModal.isExpire) {
        // 获得新人优惠券弹窗关闭
        localStorage.setItem(`new_people_activity_${this.newPeopleActivityModal.activityInfo.operating_activity_id}_${this.userInfo.visa_peer_id}`, 1);
      } else {
        // 优惠券过期提醒弹窗关闭
        let showedCouponIds = localStorage.getItem(`new_people_activity_${this.newPeopleActivityModal.activityInfo.operating_activity_id}_${this.userInfo.visa_peer_id}_expire_coupon`);
        showedCouponIds = showedCouponIds ? JSON.parse(showedCouponIds) : [];
        showedCouponIds.push(...this.newPeopleActivityModal.couponList.map(coupon => coupon.id));
        localStorage.setItem(`new_people_activity_${this.newPeopleActivityModal.activityInfo.operating_activity_id}_${this.userInfo.visa_peer_id}_expire_coupon`, JSON.stringify(showedCouponIds));
      }
    },
    // 加载营销活动
    loadMarketingActivity() {
      // 如果是金棕榈则不显示弹窗
      if (User.is_palmyou) {
        return;
      }
      Http.post('/marketing_activity_query', { shows_page_type_id: 1 })
        .then(({ marketing_activity }) => {
          // 如果没有活动 ID，说明活动不存在
          // 没有营销弹窗，则返回
          if (!marketing_activity || !marketing_activity.length) {
            this.showMarketingModal = false;
            return;
          }

          for (let index = 0; index < marketing_activity.length; index++) {
            const item = marketing_activity[index];
            // 如果已经显示过该活动弹窗，则不需要再次显示
            const marketingActivityStorage = localStorage.getItem('marketingActivity') && JSON.parse(localStorage.getItem('marketingActivity'));
            if (!marketingActivityStorage || !marketingActivityStorage[item.id]) {
              this.marketingModalInfo = item;
              this.showMarketingModal = true;
              sensorsdata.track('PopWindowExpose', {
                page_from: '首页',
                activity_name: item.title,
                activity_id: item.id,
              });
              break;
            }
          }
        }).catch(() => {
        });
    },
    // 加载充值赠送优惠券数据
    getChargeCouponData(data) {

      // 如果是金棕榈则不显示充值送优惠券弹窗
      if (User.is_palmyou) {
        this.showChargeCoupon = false;
        return;
      }

      // 如果没有活动 ID，说明活动不存在
      if (!data.id) {
        this.showChargeCoupon = false;
        return;
      }

      // 如果已经显示过该活动弹窗，则不需要再次显示
      if (localStorage.getItem('chargeCouponActivity') && JSON.parse(localStorage.getItem('chargeCouponActivity'))[data.id]) {
        this.showChargeCoupon = false;
        return;
      }

      // 活动 ID
      this.chargeCouponData.activityID = data.id;

      // 弹窗样式
      this.chargeCouponData.popStyle = data.pop_style;

      // 活动标题
      this.chargeCouponData.activityTitle = data.title;

      // 是否显示活动弹窗
      this.showChargeCoupon = !!data.pop_remind;

      // 活动时间
      // 活动结束时间年份小于 2035 时表示非长期活动
      if (parseInt(data.end_time.slice(0, 4), 10) < 2035) {
        this.chargeCouponData.activityTime = `${dateUtils.formatDateWithoutYear(data.begin_time)} - ${dateUtils.formatDateWithoutYear(data.end_time)}`;
      }

      // 图片链接
      this.chargeCouponData.imgUrl = data.pc_pop_image;

      // 活动充值送券规则
      this.chargeCouponData.chargeData = data.rules;
    },
    closeChargeCouponModel(val) {
      this.showChargeCoupon = val;
    },
    visibleSync(val) {
      this.showJingzonglvModal = val;
    },

    initPalmModalStatus() {
      if (this.userInfo.is_palmyou) {
        if (!(+this.userInfo.is_update_phone)) {
          this.showJingzonglvModal = Boolean(this.userInfo.is_first_login && !this.palmyouModalShow);
        } else {
          this.bdPhoneBindModal = true;
        }
      }
    },

    submitPhone() {
      Http.post('/palmyou_phone_update', {
        mobile_phone: this.inputPhone,
      })
        .then(() => {
          utils.msg.success('绑定成功');
          this.showJingzonglvModal = Boolean(!this.palmyouModalShow);
          this.bdPhoneBindModal = false;

          localStorage.setItem('is_update_phone', 0);
          const userInfo = Object.assign({}, this.userInfo, { is_update_phone: 0 });
          this.$store.commit('user/SET_USER_INFO', userInfo);
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
    checkPhone(value) {
      this.$nextTick(() => {
        this.inputPhone = value.replace(/[^0-9]/ig, '');
      });
    },

    // 切换全部使馆放假弹窗
    switchAllEmbassyHolidayPop() {
      this.showAllEmbassyHolidayPop = !this.showAllEmbassyHolidayPop;
    },

    // 切换最早可预约时间弹窗
    switchEarlistDatePop() {
      this.showEarlistDatePop = !this.showEarlistDatePop;
    },

    // 更改密码安全提示
    showUpdatePwdSafetyTip() {
      Http.post('/peer_account_query', {}).then((data) => {
        if (!data.check_peer_pwd_id) return;
        NoticeModal.modal({
          title: '账号安全提示',
          message: '尊敬的用户，您当前密码安全性较低，请尽快更新密码以提高账户安全性。您可以通过上上签官网-个人中心-账号设置修改密码。',
          showCancelButton: false,
          showConfirmButton: true,
          showClose: false,
          confirmButtonText: '我知道了',
          confirmMethod: () => {  
            // 标记已读
            Http.post('/peer_message_read', { id: data.check_peer_pwd_id }, { noToast: true });
          },
          cancelMethod: () => {
            console.log(11111111);
          },
        });
      });
    },

    // 获取距离屏幕的宽高，以及组件的大小
    getComponent(refName) {
      if (this.$refs[refName]) {
        const el = this.$refs[refName].$el;
        console.log('sdsadsdasda', this.$refs, el, {
          top: el.getBoundingClientRect().top,
          left: el.getBoundingClientRect().left,
          width: el.offsetWidth,
          height: el.offsetHeight,
        });
        return {
          top: el.getBoundingClientRect().top,
          left: el.getBoundingClientRect().left,
          width: el.offsetWidth,
          height: el.offsetHeight,
        };
      }
    },

  },
};
</script>

<style lang="less" scoped>
.index-page{
  background: #fff;
  position: relative;
}
</style>
<style lang="less">
.visa-dialog-modal{
  .modal-body{
    padding: 30px;
    .input-box{
      margin-bottom: 20px;
      .text{
        margin-bottom: 20px;
      }
      .el-input{
        height: 40px;
      }
    }
  }
  .footer-box{
    text-align: center;
    .submit-btn{
      color: #fff;
      background-color: #5e9be1;
      border-color: #5e9be1;
      width: 100%;
      height: 40px;
      &:hover{
        opacity: .9;
      }
      &.disabled{
        color: #fff;
        cursor: not-allowed;
        background-image: none;
        background-color: rgba(94, 155, 225, .3);
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue